import { ModuleModel } from '../../module.model.interface';
import { OrganizationModel } from '../../organization/model/organization.model';

export class CodeListItemDescriptor implements ModuleModel {
  public discriminator = 'CodeListItemDescriptor';
  public id: string;
  public codeListId: string;
  public name: string;
  public description: string;
  public sortOrder?: number;
  public organizationId: string;
  public validFrom: Date;
  public validUntil?: Date;

  public href: string;
  public modified: Date;
  public deleted: Date;

  public organizationDetail: OrganizationModel;
  public organizationName: string;

  constructor(options?: {
    id: string;
    codeListId: string;
    name: string;
    description: string;
    sortOrder?: number;
    organizationId: string;
    validFrom: Date;
    validUntil?: Date;

    href: string;
    modified: Date;
    deleted: Date;
  }) {

    if (options) {
      this.id = options.id;
      this.codeListId = options.codeListId;
      this.name = options.name;
      this.description = options.description;
      this.sortOrder = options.sortOrder;
      this.organizationId = options.organizationId;
      this.validFrom = options.validFrom;
      this.validUntil = options.validUntil;
      this.href = options.href;
      this.modified = options.modified;
      this.deleted = options.deleted;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/codelist.item/model/codelist.item.ts